import { Route, Routes } from 'react-router'
import { ResourceProvider, ShopProvider } from '../../hooks'
import { Calendar } from './Calendar'
import { Index } from './Index/index'

// Generated via https://ej2.syncfusion.com/themestudio/?theme=material
import { NotFound } from 'modules/NotFound'
import './material.min.css'

const Availability = () => (
  <ResourceProvider>
    <ShopProvider>
      <Routes>
        <Route element={<Index />} path="/">
          <Route element={<Calendar />} path="calendar" />
        </Route>
        <Route element={<NotFound />} path="*" />
      </Routes>
    </ShopProvider>
  </ResourceProvider>
)

export { Availability }
